import React from "react";
import { twMerge } from "tailwind-merge";

import validate from "../utilities/validate";
import Label from "./label.jsx";
/**
 * @typedef {import('../../types').Component} Component
 * @typedef {import('../../types').showValidation} showValidation
 */

/**
 * @typedef {object} TextFieldProps - The props for the component
 * @property {Component} component - The component
 * @property {showValidation} showValidation - Check the validation
 */

/**
 * @param {TextFieldProps} props - props
 * @returns {React.JSX.Element} React function component
 */
function TextField({ component, showValidation }) {
  const {
    placeholder,
    isHighlighted,
    componentId,
    validation,
    showCorrectResponseFeedback = true,
    label,
  } = component;
  /**
   *
   * @param {React.SyntheticEvent<HTMLInputElement>} event - synthetic event
   * @returns {void}
   */
  function updateValidation(event) {
    const { value } = event.currentTarget;
    const { isValid, key = "" } = validate("textfield", value, validation);
    if (showCorrectResponseFeedback) {
      showValidation(isValid, key, value);
    }
  }
  return (
    <>
      {label && (
        <Label
          value={label}
          htmlFor={componentId}
          showAsterisk={validation?.required ?? false}
          classes="fr-mb-2"
        />
      )}
      <input
        placeholder={placeholder}
        id={componentId}
        className={twMerge(
          "fr-w-full fr-max-w-lg fr-mb-2 fr-rounded-md fr-flex fr-items-center fr-bg-white fr-border fr-border-zinc-300 ",
          isHighlighted &&
            "fr-border-primary-500 fr-ring-primary-500 fr-text-primary-600",
        )}
        type="text"
        autoComplete="off"
        onBlur={(event) => updateValidation(event)}
        required={validation.required}
        maxLength={validation?.maxLength}
        minLength={validation?.maxLength}
      />
    </>
  );
}

export default TextField;
